import React, { Fragment, useState } from "react";
import {
    Dialog, DialogActions, DialogContent, DialogContentText,
    FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import sendRequest from '../utils/sendRequest';
import { STATUSES } from "../utils/constants";
import { MenuButtonIcon, SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function ChangeStatusDialog({ buttonLoading, setButtonLoading, po_doc_id, poName, addSnackbar, fetchPos }) {
    const [open, setOpen] = useState(false);
    const [loadingChange, setLoadingChange] = useState(false);
    const [status, setStatus] = useState('')

    const handleOpen = () => {
        setOpen(true);
        setStatus("");
    };

    const handleClose = () => {
        if (!loadingChange) {
            setOpen(false);
        }
    };

    const changeStatus = async () => {
      handleClose();
      setButtonLoading(true);
      setLoadingChange(true);
      try {
        let response = await sendRequest(
            `purchase-orders/change-status?po_doc_id=${po_doc_id}&new_status=${encodeURIComponent(status)}`
        );
        fetchPos();
        addSnackbar(response.message);
      } catch (error) {
        addSnackbar(error.message, false);
      } finally {
        setButtonLoading(false);
        setLoadingChange(false);
      }
    }

    return (
      <Fragment>
        <MenuButtonIcon
            isIcon={true}
            title={"Change Status"}
            text={""}
            icon={EditIcon}
            onClick={handleOpen}
            disabled={buttonLoading}
        />
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown={loadingChange}
            PaperProps={{
                component: 'form',
                onSubmit: event => {
                    event.preventDefault();
                    changeStatus();
                },
                autoComplete: 'off',
            }}
        >
            <CustomDialogTitle
                header={"Change PO Status"}
                poName={poName}
            />
            <DialogContent>
                <DialogContentText>
                    Please select the desired new PO status
                </DialogContentText>
                <FormControl fullWidth variant="standard" margin="dense">
                    <InputLabel id="currency-label">Status</InputLabel>
                    <Select
                        labelId="status-label"
                        id="status"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        label="Status"
                    >
                        {Object.values(STATUSES).map((statusValue) => (
                            <MenuItem key={statusValue} value={statusValue}>
                                {statusValue}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleClose} disabled={loadingChange}>Cancel</CancelButton>
                <SubmitButton
                    showSpinner={loadingChange}
                    text={"Submit"}
                    type="submit"
                    disabled={loadingChange || status === ""}
                />
            </DialogActions>
        </Dialog>
      </Fragment>
    );
}